export default __webpack_public_path__ + "media/images/features/yado/step_3-5460a4a6c31a67a4fe7a0e1b246c3eeb.jpg";